import { authAPI } from "../auth/auth";

export const savedReceiversAPI = {
    async getSavedReceivers () {
        const resp = await fetch("/api/saved-receivers").catch((error) => {
            console.log(error);
        })
    
        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.getSavedReceivers();
            }
            return {
                unauthorized: true,
            };
        }
    
        let error = null;
        let body = await resp.json().catch((err) => error = err);
        if (error || !body) {
            return {
                "ok": false,
                err: "something_went_wrong",
            };
        }
    
        if(body.ok) {
            return {
                "ok": true,
                "data": body.receivers,
            };
        }
    
        return {
            "ok": false,
            "err": "something_went_wrong" 
        };
    },
    
    async createSavedReceiver (receiver) {
        const resp = await fetch("/api/saved-receivers", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(receiver),
        }).catch((error) => {
            console.log(error);
        })
    
        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.createSavedReceiver(receiver);
            }
            return {
                unauthorized: true,
            };
        }
    
        let error = null;
        let body = await resp.json().catch((err) => error = err);
        if (error || !body) {
            return {
                "ok": false,
                err: "something_went_wrong",
            };
        }

        if(body.ok) {
            return {
                "ok": true,
                "data": body.receiver,
            };
        }

        return {
            "ok": false,
            "err": "something_went_wrong"
        };
    
    },

    async updateSavedReceiver (receiver) {
        const resp = await fetch(`/api/saved-receivers/${receiver.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(receiver),
        }).catch((error) => {
            console.log(error);
        })
    
        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.updateSavedReceiver(receiver);
            }
            return {
                unauthorized: true,
            };
        }
    
        let error = null;
        let body = await resp.json().catch((err) => error = err);
        if (error || !body) {
            return {
                "ok": false,
                err: "something_went_wrong",
            };
        }

        if(body.ok) {
            return {
                ok: true,
                data: body.receiver,
            };
        }

        if (body.err === "receiver not found") {
            return {
                ok: false,
                err: "receiver_not_found",
            };
        }

        if (body.err === "city not found") {
            return {
                ok: false,
                err: "city_not_found",
            };
        }

        if(body.err === "country not found") {
            return {
                ok: false,
                err: "country_not_found",
            }
        }

        return {
            "ok": false,
            "err": "something_went_wrong"
        };
    },

    async deleteSavedReceiver (receiverID) {
        const resp = await fetch("/api/saved-receivers/" + receiverID, {
            method: "DELETE",
            }).catch((error) => {
            console.log(error);
        })

        if (resp.status === 401) {
            let refreshed = await authAPI.refreshToken();
            if (refreshed) {
                return await this.deleteSavedReceiver(receiverID);
            }
            return {
                unauthorized: true,
            };
        }

        let error = null;
        let body = await resp.json().catch((err) => error = err);
        if (error || !body) {
            return {
                "ok": false,
                err: "something_went_wrong",
            };
        }

        if(body.ok) {
            return {
                ok: true,
            };
        }

        if (body.err === "receiver not found") {
            return{
                ok: true,
            }
        }

        return {
            "ok": false,
            "err": "something_went_wrong"
        };
    },
}